import CreateSavedSearchModal from './CreateSavedSearchModal.container';

export default CreateSavedSearchModal;
